/**
 * 前端配置读取工具.
 *
 * @author yusangeng@outlook.com
 */
import { __assign } from "tslib";
import Reader from "./Reader";
import helper from "./helper";
var DEFAULT_GLOBAL_NAME = "__Konph";
function getSearch() {
    try {
        return globalThis.location.search;
    }
    catch (err) {
        // TODO: 兼容node命令行参数
        return "";
    }
}
/**
 * 读取配置数据.
 *
 * @param {KonphOptions<T>} options 读取设置, 键为感兴趣的配置字段名(不区分大小写, 两边的空格会被trim掉),
 *   值为相应的读取配置, 支持fit, deps, defaultValue, 具体见README.
 * @param {string|KonphInitData<T>} name 全局配置变量名, 默认为`__Konph`,
 *   如果传入一个对象, 则不读取全局变量和url参数,
 *   而是直接读传入对象的url和global字段, 用来在非浏览器环境中测试.
 * @returns {KonphResult<T>} 配置读取结果, 格式为键值对.
 * @function
 */
function getKonph(options, name) {
    var _a, _b, _c;
    var globalConf;
    var url;
    var g = globalThis;
    if (!name || (typeof name === "string" && !g[name])) {
        name = DEFAULT_GLOBAL_NAME;
    }
    if (typeof name === "string") {
        globalConf = (_a = g[name]) !== null && _a !== void 0 ? _a : {};
        url = getSearch();
    }
    else {
        globalConf = (_b = name.global) !== null && _b !== void 0 ? _b : {};
        url = (_c = name.url) !== null && _c !== void 0 ? _c : "";
    }
    // 环境变量会被全局变量覆盖
    if (process) {
        var _d = process.env, env = _d === void 0 ? {} : _d;
        globalConf = __assign(__assign({}, env), globalConf);
    }
    var reader = new Reader(globalConf, url, options);
    var ret = Object.keys(options)
        .map(function (key) { return key.trim().toLowerCase(); })
        .map(function (key) {
        return { key: key, value: reader.item(key) };
    })
        .reduce(function (prev, el) {
        // fixme
        prev[el.key] = el.value;
        return prev;
    }, {});
    return ret;
}
var prv = function (value) {
    return {
        __konph_private_item__: true,
        value: value
    };
};
var konph = (function () {
    var k = getKonph;
    k.helper = helper;
    k.private = prv;
    return k;
})();
export default konph;
//# sourceMappingURL=data:application/json;base64,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